import React from 'react'
import About1 from '../../img/about/about1.JPG';
import About2 from '../../img/about/about2.jpg';
const About = () => {
    return (
        <div className='d-flex justify-content-center align-items-center flex-column'>
            <div id="carouselExampleControls" class="carousel slide py-3" data-ride="carousel">
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <img className='d-block w-100' src={About1} alt="First Image Project" />
                    </div>
                    <div class="carousel-item">
                        <img className='d-block w-100' src={About2} alt="First Image Project" />
                    </div>

                </div>
                <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="sr-only">Previous</span>
                </a>
                <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="sr-only">Next</span>
                </a>
            </div>
            <h1 className='text-white py-5'>About Us</h1>
            <p className='lead text-white'>
                As a team, we are 11th grade students of Bahçeşehir Science and Technology High School.
                We have been trying to improve ourselves by participating in various robotic competitions for 4 years with our team of 5 people.
                We want to be useful by supporting each other in different areas.
                </p>
            <p className='lead text-white'>
                <h4 className='text-center py-2 text-white'>IMPACT</h4>
As a team, we aimed to enable astronauts to work more efficiently by targeting the difficulties they experience in space and to minimize the difficulties they experience.
We developed the tools to guide us through the data obtained on every surface to make great improvements.
We know that the technologies developed for space occupy an important place in our daily life.
                </p>
        </div>
    )
}

export default About
